export default "__VITE_ASSET__53f5b6c3__"